import { Hub, BrowserClient, defaultIntegrations, makeMain } from '@sentry/browser';
import PaymentError from '../components/PaymentError/PaymentError.js';

let sentryService = null;
function getSentryService(env, defaultConfig) {
    if (sentryService === null) {
        const { appVersion, sentryDsn } = defaultConfig;
        sentryService = new SentryService(sentryDsn, env, appVersion);
    }
    else {
        sentryService.maybeReset(env);
    }
    return sentryService;
}
const captureException = (error) => {
    return sentryService !== null ? sentryService.captureException(error) : new PaymentError(error);
};
class SentryService {
    env = 'dev';
    appVersion;
    dsn;
    state = { status: 'UN_INITIALIZED' };
    errorQueue = [];
    constructor(dsn, env, appVersion) {
        this.env = env;
        this.dsn = dsn;
        this.appVersion = appVersion;
        this.initializeSentry();
    }
    initializeSentry = (whitelistUrls) => {
        try {
            const hub = new Hub(new BrowserClient({
                dsn: this.dsn,
                environment: this.env,
                integrations: [...defaultIntegrations],
                whitelistUrls,
            }));
            hub.configureScope((scope) => {
                scope.setTags({ version: this.appVersion });
            });
            makeMain(hub);
            this.state = {
                status: 'INITIALIZED',
                hub,
            };
        }
        catch (error) {
            this.errorQueue.push(error);
        }
    };
    processErrorQueue = (hub) => {
        this.errorQueue.forEach((error) => hub.captureException(error));
        this.errorQueue = [];
    };
    captureException = (sentryError) => {
        const isNotProdEnv = this.env !== 'prod';
        if (this.state.status === 'UN_INITIALIZED') {
            this.initializeSentry();
        }
        const paymentError = new PaymentError(sentryError);
        if (this.state.status === 'INITIALIZED') {
            this.processErrorQueue(this.state.hub);
            if (sentryError.error) {
                // if we have an explicit error, then that is what we should send to Sentry
                this.state.hub.captureException(sentryError.error);
                if (isNotProdEnv)
                    console.error(sentryError.error);
            }
            else {
                this.state.hub.captureException(paymentError);
                if (isNotProdEnv)
                    console.error(paymentError);
            }
        }
        else if (sentryError.error) {
            // as above, if we have an explicit error, then that is what we should queue
            this.errorQueue.push(sentryError.error);
        }
        else {
            this.errorQueue.push(paymentError);
        }
        return paymentError;
    };
    maybeReset(env) {
        if (this.env !== env) {
            const oldEnv = this.env;
            this.env = env;
            this.initializeSentry();
            this.captureException(new Error(`SentryService switch from environment ${oldEnv} to ${env}`));
        }
    }
}

export { captureException, SentryService as default, getSentryService };
//# sourceMappingURL=sentryService.js.map
